
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    /* featured-collection carousels: page by visible count */
    document.querySelectorAll('.collection-slider-row').forEach(function(row){
      var slider = row.querySelector('.slider'); if(!slider) return;
      ['prev','next'].forEach(function(name){
        var btn = row.querySelector('button[name="'+name+'"]'); if(!btn) return;
        btn.addEventListener('click', function(e){
          e.stopImmediatePropagation(); e.preventDefault();
          var item = slider.querySelector('.slider__item');
          var w = item ? item.getBoundingClientRect().width + 14 : slider.clientWidth;
          var per = window.innerWidth < 768 ? 2 : 4;
          slider.scrollBy({left: (name==='next'?1:-1) * w * per, behavior:'smooth'});
        }, true);
      });
    });
    /* tag-us strips: arrows with loop, one item per click */
    document.querySelectorAll('.shopify-section[id$="__insta"]').forEach(function(sec){
      var slider = sec.querySelector('.slider'); if(!slider) return;
      if (sec.querySelector('.almond-strip-nav')) return;
      var wrap = slider.parentElement;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      [['prev','M15 5l-7 7 7 7'],['next','M9 5l7 7-7 7']].forEach(function(cfg){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'almond-strip-nav almond-strip-nav--' + cfg[0];
        b.setAttribute('aria-label', cfg[0] === 'prev' ? 'Previous' : 'Next');
        b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.6" stroke-linecap="square"><path d="' + cfg[1] + '"/></svg>';
        b.addEventListener('click', function(){
          var item = slider.querySelector('.slider__item'); if(!item) return;
          var grid = slider.querySelector('.slider__grid');
          var gapPx = grid ? parseFloat(getComputedStyle(grid).columnGap) || 13 : 13;
          var step = item.getBoundingClientRect().width + gapPx;
          var max = slider.scrollWidth - slider.clientWidth;
          if (cfg[0] === 'next') {
            if (slider.scrollLeft >= max - 4) { slider.scrollTo({left: 0, behavior: 'smooth'}); }
            else { slider.scrollBy({left: step, behavior: 'smooth'}); }
          } else {
            if (slider.scrollLeft <= 4) { slider.scrollTo({left: max, behavior: 'smooth'}); }
            else { slider.scrollBy({left: -step, behavior: 'smooth'}); }
          }
        });
        wrap.appendChild(b);
      });
    });
    /* rating click: smooth scroll to reviews */
    document.querySelectorAll('.almond-rating').forEach(function(r){
      r.addEventListener('click', function(){
        var sec = document.querySelector('[id$="__reviews"]');
        if (sec) sec.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });
    /* collection filters: collapse all groups by default (almond style) */
    document.querySelectorAll('.filters .filter-group__heading').forEach(function(h){
      var targetSel = h.getAttribute('data-toggle-target');
      if (!targetSel) return;
      var t = document.querySelector(targetSel);
      if (t && t.offsetParent !== null) { h.click(); }
    });
  });
})();

(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var pag = document.querySelector('.pagination');
    if (!pag || pag.querySelector('.almond-pag-track')) return;
    var cells = [].slice.call(pag.querySelectorAll('.pagination__number, .pagination__next')).filter(function(c){ return c.textContent.trim() !== '…' || c.querySelector('a'); });
    cells = cells.filter(function(c){ return c.offsetParent !== null; });
    if (!cells.length) return;
    var pr = pag.getBoundingClientRect();
    var first = cells[0].getBoundingClientRect();
    var last = cells[cells.length-1].getBoundingClientRect();
    var left = first.left - pr.left;
    var width = last.right - first.left;
    var track = document.createElement('div');
    track.className = 'almond-pag-track';
    track.style.left = Math.round(left) + 'px';
    track.style.width = Math.round(width) + 'px';
    pag.appendChild(track);
    var current = pag.querySelector('.underline--not-link');
    var idx = 0;
    for (var i = 0; i < cells.length; i++) { if (cells[i] === current || cells[i].contains(current) || (current && current.contains(cells[i]))) { idx = i; break; } }
    var seg = width / cells.length;
    var bar = document.createElement('div');
    bar.className = 'almond-pag-bar';
    bar.style.left = Math.round(left + idx * seg) + 'px';
    bar.style.width = Math.round(seg) + 'px';
    pag.appendChild(bar);
  });
})();

/* upsell horizontal scroller: progress-bar met pijltjes (mobiel) */
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    document.querySelectorAll('.almond-upsell__grid').forEach(function(grid){
      var wrap = grid.parentElement;
      if (wrap.querySelector('.almond-upsell-progress')) return;
      var prog = document.createElement('div');
      prog.className = 'almond-upsell-progress';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'almond-upsell-arrow almond-upsell-arrow--prev'; prev.setAttribute('aria-label','Previous');
      prev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.8" stroke-linecap="square"><path d="M15 5l-7 7 7 7"/></svg>';
      var track = document.createElement('div'); track.className = 'almond-upsell-track';
      var thumb = document.createElement('div'); thumb.className = 'almond-upsell-thumb'; track.appendChild(thumb);
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'almond-upsell-arrow almond-upsell-arrow--next'; next.setAttribute('aria-label','Next');
      next.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.8" stroke-linecap="square"><path d="M9 5l7 7-7 7"/></svg>';
      prog.appendChild(prev); prog.appendChild(track); prog.appendChild(next);
      wrap.insertBefore(prog, grid.nextSibling);
      function update(){
        var max = grid.scrollWidth - grid.clientWidth;
        var tw = track.clientWidth;
        var ratio = grid.scrollWidth > 0 ? grid.clientWidth / grid.scrollWidth : 1;
        var thumbW = Math.max(28, Math.round(ratio * tw));
        thumb.style.width = thumbW + 'px';
        var p = max > 0 ? grid.scrollLeft / max : 0;
        thumb.style.left = Math.round(p * (tw - thumbW)) + 'px';
      }
      function step(dir){
        var item = grid.querySelector('.almond-upsell__item');
        var w = item ? item.getBoundingClientRect().width + 8 : 200;
        grid.scrollBy({left: dir * w, behavior: 'smooth'});
      }
      grid.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      prev.addEventListener('click', function(){ step(-1); });
      next.addEventListener('click', function(){ step(1); });
      setTimeout(update, 120); update();
    });
  });
})();
